import type { AptiRequestConfig } from "@/lib/types/api";
import { httpAuth } from "@/utils/axios";

export type UnreadMessageCountResponse = {
  unread_count: number;
};

export const messagingRequestsTyped = {
  fetch_unread_message_count: function (): Promise<UnreadMessageCountResponse> {
    const config = {
      // 403 means the user lacks messaging access; skip token refresh retry
      errorTypeConfig: { ForbiddenException: { allowRetry: false } },
      method: "POST",
      params: { showLoader: false },
      preventAllErrorToast: true,
      url: "/v1/messaging/unread_message_count",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<UnreadMessageCountResponse>;
  },
};
